import * as angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';
import { AttachmentService } from '@go-modules/services/api/attachments/attachments.service';
import { mediaModel } from 'go-modules/models/media';

export const attachmentServiceModule = angular.module('attachmentService', [
	mediaModel
])
	.factory('ngxAttachmentService', downgradeInjectable(AttachmentService))
	.name;
